import { Injectable, OnDestroy } from '@angular/core';
import { AnimationService } from './animation.service';
import { NavController } from '@ionic/angular';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService implements OnDestroy {
  previousUrl: string = '';
  currentUrl: string = '';
  private routerSub?: Subscription;

  constructor(
    private navController: NavController,
    private animationService: AnimationService,
    private router: Router
  ) {
    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }

  navigateDissolve(path: string, extras?: NavigationExtras) {
    this.navController.navigateForward(path, {
      ...extras,
      animation: this.animationService.dissolveAnimation()
    });
  }

  navigateRootDissolve(path: string, extras?: NavigationExtras) {
    this.navController.navigateRoot(path, {
      ...extras,
      animation: this.animationService.dissolveAnimation()
    });
  }

  navigateSlideInRight(path: string, extras?: NavigationExtras) {
    return this.navController.navigateForward(path, {
      ...extras,
      animation: this.animationService.slideInRightAnimation()
    });
  }

  navigateSlideInLeft(path: string, extras?: NavigationExtras) {
    this.navController.back({
      ...extras,
      animation: this.animationService.slideInLeftAnimation()
    });
  }

  navigateRootSlideInLeft(path: string, extras?: NavigationExtras) {
    this.navController.navigateRoot(path, {
      ...extras,
      animation: this.animationService.slideInLeftAnimation()
    });
  }

  navigateInstant(path: string, extras?: NavigationExtras) {
    this.navController.navigateForward(path, {
      ...extras,
      animation: this.animationService.instantAnimation()
    });
  }

  navigateRootInstant(path: string, extras?: NavigationExtras) {
    this.navController.navigateRoot(path, {
      ...extras,
      animation: this.animationService.instantAnimation()
    });
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }

  getQueryParams(url: string) {
    const params: Record<string, string> = {};
    const searchParams = new URL(url, location.origin).searchParams;

    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  }
}
